import { Hero, Schemes, Contact, About, Testimonial, Services, FeaturesSection, Partners } from '../sections';
import { NewHero } from '../sections/hero/NewHero';

export default function Home() {
  return (
    <div>
      <Hero />
      {/* <NewHero /> */}
      <About />
      <Services />
      <FeaturesSection />
      <Schemes />
      <Testimonial />
      <Contact />
      <Partners />
    </div>
  );
}
